module.exports = __webpack_public_path__ + "static/media/galerija_2017 (5).d669ee73.jpg";